import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CqCriteriaGroupService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  all(query?: any) {
    return this.get('/cq-all-criteria-groups', query);
  }

  list(query?: any) {
    return this.get('/cq-criteria-groups', query);
  }

  create(body: any) {
    return this.post('/cq-criteria-groups', body);
  }

  find(id) {
    return this.get('/cq-criteria-groups/' + id);
  }

  update(id, body) {
    return this.put('/cq-criteria-groups/' + id, body);
  }

  _delete(id) {
    return this.delete('/cq-criteria-groups/' + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CqCriteriaGroup.service.ts